<template>
  <p
    class="article-paragraph"
    v-html="textMarkup" />
</template>

<script>
// import compact from 'lodash/compact'
export default {
  name: 'ArticleParagraph',
  props: {
    title: {
      type: String
    },
    text: {
      type: String,
      required: true
    },
    speech: {
      type: String
    },
    spoken: {
      type: Boolean
    }
  },
  computed: {
    textTrim () {
      let text = this.text.replace(/\s+/g, ' ')
      return text
    },
    textMarkup () {
      if (this.speech && this.textTrim.includes(this.speech)) {
        const endings = this.textTrim.split(this.speech)
        let text = '<span class="speech">' + this.speech + '</span>'
        if (endings[0]) text = '<span class="spoken">' + endings[0] + '</span> ' + text
        if (endings[1]) text += ' <span class="future">' + endings[1] + '</span>'
        return text
      }
      if (this.speech === this.title + '.') return '<span class="future">' + this.textTrim + '</span>'
      return '<span class="spoken">' + this.textTrim + '</span>'
    }
  }
}
</script>

<style lang="scss">
.article-paragraph {
  .spoken {
    color: var(--f7-block-text-color);
  }
  .speech {
    color: var(--f7-theme-color);
  }
  .future {
    color: #ccc;
  }
}
.dark {
  .article-paragraph {
    .future {
      color: #333;
    }
  }
}
</style>
